import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  GroupIcon,
} from "../../assets/icons";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Link } from "react-router-dom";
import authorizedApi from "../../api/axiosAuthorizedInstance";

export default function Dashboard() {
  const [data, setData] = useState({});
  const apiUrl = import.meta.env.VITE_API_URL;
  const contentUrl = import.meta.env.VITE_CONTENT_URL;

  useEffect(() => {
      const fetchData = async () => {
        // try {
          // const response = await fetch(apiUrl + "/api/v1/dashboard");
          // if (!response.ok) {
          //   throw new Error(`HTTP error! status: ${response.status}`);
          // }
          // const result = await response.json();
          // setData(result);

          authorizedApi.get(apiUrl + "/api/v1/dashboard/data")
          .then(response => {console.log("data data data data");console.log(response.data)
    setData(response.data);
  });
        // } catch (error) {
        //   console.error("Error fetching data:", error);
        // }
      };
      fetchData();
    }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>

      <div className="flex flex-row w-full">
        <div className="flex-3/12 w-full">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:gap-6">
            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
              </div>

              <div className="flex items-end justify-between mt-5">
                <div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Approved Registrations
                  </span>
                  <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
                    {data.totalApproved}
                  </h4>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
              </div>
              <div className="flex items-end justify-between mt-5">
                <div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Failed Registrations
                  </span>
                  <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
                    {data.totalFailed}
                  </h4>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="flex-9/12 w-full">
        
        {/* Recent Registrations */}
<div className="overflow-hidden ml-5 rounded-2xl border border-gray-200 bg-white px-4 pb-3 pt-4 dark:border-gray-800 dark:bg-white/[0.03] sm:px-6">
      <div className="flex flex-col gap-2 mb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">
            Recent Registrations
          </h3>
        </div>

        <div className="flex items-center gap-3">
          
          <Link to="/admin/registrations" className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-theme-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
            See all
          </Link>
        </div>
      </div>
      <div className="max-w-full overflow-x-auto">
        <Table>

          <TableHeader className="border-gray-100 dark:border-gray-800 border-y">
          
            <TableRow>
              <TableCell
                isHeader
                className="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                User
              </TableCell>
              <TableCell
                isHeader
                className="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Email
              </TableCell>
              <TableCell
                isHeader
                className="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Mobile
              </TableCell>
              <TableCell
                isHeader
                className="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                ID Number
              </TableCell>

              <TableCell
                isHeader
                className="py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              ></TableCell>
            </TableRow>

          </TableHeader>

          <TableBody className="divide-y divide-gray-100 dark:divide-gray-800">
            {data.recentSessions?.map((session) => (
              <TableRow key={session.id}>
                <TableCell className="py-3">
                  <div className="flex items-center gap-3">
                    <div className="h-[50px] w-[50px] overflow-hidden rounded-md">
                      <img
                              width={40}
                              height={40}
                              src={contentUrl + session.imageUrl}
                              alt="Image"
                            />
                    </div>
                    <div>
                      <p className="font-medium text-gray-800 text-theme-sm dark:text-white/90">
                        {session.firstName}
                      </p>
                      <span className="text-gray-500 text-theme-xs dark:text-gray-400">
                        {session.lastName}
                      </span>
                    </div>
                  </div>
                </TableCell>
                <TableCell className="py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                  {session.email}
                </TableCell>
                <TableCell className="py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                  {session.mobile}
                </TableCell>
                <TableCell className="py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                  {session.idNumber}
                </TableCell>
                <TableCell className="py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                  <Link to={`/admin/registrations/${session.sessionId}/detail`} className="mt-3 inline-block text-sm font-medium text-gray-500 underline dark:text-gray-400">
                        View
                        </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
        {/* End - recent orders */}

        </div>
      </div>
    </>
  );
}
